import axios from "axios";
import {
  RESET_PASSWORD,
  TEMPORARY_PASSWORD_CONFIRMED,
  RESET_PASSWORD_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  CLEAR_EMAIL,
} from "./types";
import setAuthToken from "../utilities/setAuthToken";

// Load User
export const loadUser = () => async (dispatch) => {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }

  try {
    const res = await axios.get(`/api/profile`);

    dispatch({
      type: USER_LOADED,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

// Reset User Password
export const resetPassword = (email) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ email });

  try {
    const res = await axios.post("/api/email", body, config);

    dispatch({
      type: RESET_PASSWORD,
      payload: res.data,
    });
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      console.error(errors);
    }

    dispatch({
      type: RESET_PASSWORD_FAIL,
    });
  }
};

// Confirm Temporary Password
export const temporaryPasswordConfirm =
  (email, password) => async (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({ email, password });

    try {
      const res = await axios.post(
        "/api/email/temporary_password",
        body,
        config
      );

      dispatch({
        type: TEMPORARY_PASSWORD_CONFIRMED,
        payload: res.data,
      });
    } catch (err) {
      const errors = err.response.data.errors;

      if (errors) {
        console.error(errors);
      }

      dispatch({
        type: RESET_PASSWORD_FAIL,
      });
    }
  };

// Register Innovator
export const resetUserPassword = (email, password) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({
    email,
    password,
  });

  try {
    const res = await axios.post("/api/email/reset_password", body, config);

    dispatch({
      type: REGISTER_SUCCESS,
      payload: res.data,
    });

    dispatch(loadUser());
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      console.error(errors);
    }

    dispatch({
      type: REGISTER_FAIL,
    });
  }
};

// Clear Email State
export const clearEmail = () => async (dispatch) => {
  dispatch({ type: CLEAR_EMAIL });
};
